const React = require('react');
const upperFirst = require("mn-utils/upperFirst");
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonUp = require('../../../dumb/Button/Up');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const RowB = require('../../../dumb/Row/B');
const ColA = require('../../../dumb/Col/A');
const ColB = require('../../../dumb/Col/B');
const {TableNumberColAmin} = require("../../../dumb/TableNumberCol");

const {
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/withdraws').apiAdminWithdrawsList,
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const amount = data.amount || '';
      const time = data.time || '';
      return (
        <RowA>
          <ColA className="w(|min)115">
            <DisplayDateTimeAdmin date={time} />
          </ColA>
          <ColA className="fx1 wmin80">
            <Tooltip>{data.bank_name}</Tooltip>
          </ColA>
          <ColA className="w150">
            <Tooltip>{upperFirst(data.status)}</Tooltip>
          </ColA>
          <ColA className="w150">
            <TableNumberColAmin
              value={amount}
              type="fiat"
            />
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Withdrawals</CaptionA>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin800 rlv h">
                <div>
                  <RowB>
                    <ColB className="w(|min)115">Date & Time</ColB>
                    <ColB className="fx1 wmin80">Bank</ColB>
                    <ColB className="w150">Status</ColB>
                    <ColB className="w150 tr">EUR</ColB>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
